export default "__VITE_ASSET__BdHfgYWE__"